import { Link } from "react-router-dom";
import { css } from "styled-system/css";
import { CalendarDays, Clock3, Sparkles } from "lucide-react";
import type { ReactNode } from "react";

const mockSlots = ["10:00", "10:45", "11:30", "16:00", "16:45", "18:15"];

export function BookDemoPage() {
  return (
    <main
      className={css({
        minH: "100vh",
        bg: "linear-gradient(160deg, #eef2ff 0%, #e0f2fe 55%, #f8fafc 100%)",
        py: { base: "10", md: "14" },
      })}
    >
      <div className={css({ maxW: "1100px", mx: "auto", px: { base: "4", md: "6" } })}>
        <div className={css({ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "3", mb: "8" })}>
          <Link to="/" className={css({ color: "#334155", fontSize: "sm", fontWeight: "semibold", textDecoration: "none", _hover: { color: "#0f172a" } })}>
            ← Volver a la landing
          </Link>
          <Link
            to="/auth/register"
            className={css({
              bg: "#4F46E5",
              color: "white",
              textDecoration: "none",
              px: "4",
              py: "2.5",
              rounded: "lg",
              fontSize: "sm",
              fontWeight: "bold",
              _hover: { bg: "#4338CA" },
            })}
          >
            Crear cuenta
          </Link>
        </div>

        <div className={css({ display: "grid", gridTemplateColumns: { base: "1fr", lg: "320px 1fr" }, gap: "6" })}>
          <aside className={css({ rounded: "2xl", borderWidth: "1px", borderColor: "#dbeafe", bg: "white", p: "6", boxShadow: "0 16px 36px rgba(15,23,42,0.08)" })}>
            <div className={css({ w: "16", h: "16", rounded: "full", bg: "linear-gradient(135deg,#4F46E5,#0EA5E9)", mb: "4" })} />
            <h1 className={css({ fontSize: "xl", fontWeight: "bold", color: "#0f172a" })}>Demo Studio</h1>
            <p className={css({ mt: "1", color: "#64748b", fontSize: "sm" })}>Reserva online de ejemplo</p>
            <p className={css({ mt: "4", fontSize: "sm", color: "#475569", lineHeight: "1.7" })}>
              Esta es una agenda de demostracion para que veas la experiencia completa de reserva antes de registrarte.
            </p>
            <div className={css({ mt: "6", p: "3", rounded: "xl", bg: "#eef2ff", color: "#3730a3", fontSize: "sm", fontWeight: "semibold", display: "flex", gap: "2", alignItems: "center" })}>
              <Sparkles size={16} /> Modo demo (sin cobros reales)
            </div>
          </aside>

          <section className={css({ rounded: "2xl", borderWidth: "1px", borderColor: "#dbeafe", bg: "white", p: { base: "5", md: "7" }, boxShadow: "0 18px 44px rgba(15,23,42,0.08)" })}>
            <h2 className={css({ fontSize: "2xl", fontWeight: "bold", color: "#0f172a" })}>Reserva tu turno en 3 pasos</h2>
            <p className={css({ mt: "2", color: "#64748b" })}>Asi se ve el flujo para tus clientes.</p>

            <div className={css({ mt: "6", display: "grid", gap: "4", gridTemplateColumns: { base: "1fr", md: "repeat(3, 1fr)" } })}>
              <StepCard title="1. Elegir servicio" desc="Corte + Barba (45 min)" icon={<CalendarDays size={18} />} />
              <StepCard title="2. Fecha y hora" desc="Jueves 10/04, 16:45" icon={<Clock3 size={18} />} />
              <StepCard title="3. Confirmar datos" desc="Nombre, email y WhatsApp" icon={<Sparkles size={18} />} />
            </div>

            <div className={css({ mt: "8" })}>
              <p className={css({ fontSize: "sm", fontWeight: "bold", color: "#334155", mb: "3" })}>Horarios disponibles (demo)</p>
              <div className={css({ display: "grid", gridTemplateColumns: { base: "repeat(3, 1fr)", md: "repeat(6, 1fr)" }, gap: "2.5" })}>
                {mockSlots.map((slot) => (
                  <button
                    key={slot}
                    type="button"
                    className={css({
                      borderWidth: "1px",
                      borderColor: "#c7d2fe",
                      bg: "#eef2ff",
                      color: "#3730a3",
                      rounded: "lg",
                      py: "2.5",
                      fontSize: "sm",
                      fontWeight: "semibold",
                      cursor: "pointer",
                      _hover: { bg: "#e0e7ff" },
                    })}
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>

            <div className={css({ mt: "8", display: "flex", justifyContent: "space-between", gap: "3", flexWrap: "wrap" })}>
              <p className={css({ color: "#64748b", fontSize: "sm" })}>Despues de reservar, llega recordatorio por WhatsApp y email.</p>
              <Link to="/auth/register" className={css({ color: "white", bg: "#0f172a", textDecoration: "none", px: "5", py: "2.5", rounded: "lg", fontWeight: "bold", _hover: { opacity: 0.92 } })}>
                Quiero este sistema
              </Link>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}

function StepCard({ title, desc, icon }: { title: string; desc: string; icon: ReactNode }) {
  return (
    <div className={css({ rounded: "xl", borderWidth: "1px", borderColor: "#e2e8f0", bg: "#f8fafc", p: "4" })}>
      <div className={css({ color: "#4F46E5", mb: "2" })}>{icon}</div>
      <p className={css({ fontWeight: "bold", color: "#0f172a", fontSize: "sm" })}>{title}</p>
      <p className={css({ mt: "1", color: "#64748b", fontSize: "sm" })}>{desc}</p>
    </div>
  );
}
